module.exports = __webpack_public_path__ + "static/media/S1P3_genetic-predisposition.9f7ed3ec.mp3";